import _ from 'lodash';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import {KNOB_DIRECTIONS} from 'crazyEditor/core/constants/editorConstants';
import {getElementDefinitionProps, getElementMethods} from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import {connect} from 'react-redux';
import {updateDesktopElement} from 'crazyEditor/redux/modules/element/actions/desktopElementActions';
import {editDesktopElement} from 'crazyEditor/core/elements/utils/elementAddUpdateUtils';
import {zIndexMouseCatcher} from 'crazyEditor/core/globals';
import {getSelectedElementsForCopy} from 'crazyEditor/redux/modules/element/elementSelectors';
import {elementTypes} from 'crazyEditor/components/Elements/index';
import {MOUSE_CATCHER_ID} from 'crazyEditor/core/constants/editorConstants';
import Clipboard from 'clipboard-js';
import {pasteElements, deleteElement} from 'crazyEditor/redux/modules/element/actions/desktopElementActions';
import {anyDialogOpen} from 'crazyEditor/redux/modules/stage/stageSelectors';
import * as CopyPasteUtils from './CopyPasteUtils';

@connect(
  state => ({
    selectedElements: getSelectedElementsForCopy(state),
    selectedElementIds: state.stage.selectedElementIds,
    state: state,
  }),
  {pasteElements, deleteElement},
  false,
  {forwardRef: true}
)
export default class CopyPasteListener extends Component {
  componentDidMount() {
    document.addEventListener('cut', this.onCut);
    document.addEventListener('copy', this.onCopy);
    document.addEventListener('paste', this.onPaste);
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    document.removeEventListener('cut', this.onCut);
    document.removeEventListener('copy', this.onCopy);
    document.removeEventListener('paste', this.onPaste);
  }

  onCut = event => {
    if (this.filterOutEvent(event)) {
      return;
    }
    const {deleteElement, selectedElementIds} = this.props;
    this.handleElementsCopy(event);
    deleteElement(selectedElementIds);
  };

  onCopy = event => {
    if (this.filterOutEvent(event)) {
      return;
    }
    this.handleElementsCopy(event);
  };

  onPaste = event => {
    if (this.filterOutEvent(event)) {
      return;
    }
    event.clipboardData.items[0].getAsString(this.handleElementsPaste);
  };

  handleElementsCopy = event => {
    const {selectedElements} = this.props;
    const elementsJSONString = JSON.stringify({clElements: selectedElements});
    CopyPasteUtils.setVirtualClipboardContent(elementsJSONString);
    if (!event || _.isEmpty(event.clipboardData.items)) {
      Clipboard.copy(elementsJSONString);
    } else {
      event.clipboardData.items[0].getAsString(clipboardContent => {
        if (clipboardContent !== elementsJSONString) {
          // ensure no recursion
          Clipboard.copy(elementsJSONString);
        }
      });
    }
  };

  handleElementsPaste = clipboardContent => {
    const {pasteElements} = this.props;
    if (!clipboardContent) {
      clipboardContent = CopyPasteUtils.getVirtualClipBoardContent();
    }
    try {
      const {clElements} = JSON.parse(clipboardContent);
      pasteElements(clElements);
    } catch (e) {
      // no need to paste
    }
  };

  filterOutEvent(event) {
    const {state} = this.props;
    const target = event.target;
    if (
      target.id !== MOUSE_CATCHER_ID &&
      ['BODY', 'HTML'].indexOf(target.tagName) === -1 &&
      target.getAttribute('type') !== 'button'
    ) {
      console.log('Copy event ignored for element:', target);
      return true;
    }
    if (anyDialogOpen(state)) {
      return true;
    }
    return false;
  }

  render() {
    return null;
  }
}
